<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2020 (original work) Open Assessment Technologies SA ;

    import { Icon } from '@oat-sa-private/ui-elements';
    import { createEventDispatcher } from 'svelte';
    import FlyoutMenu from '../flyoutMenu/FlyoutMenu.svelte';
    import { __ } from '@oat-sa-private/ui-core';

    export let value;
    export let items = [];
    export let disabled = false;
    export let anchoring = 'top left';
    export let inverted = false;

    const dispatch = createEventDispatcher();

    let showFlyout = false;
    let labelElement;

    $: currentLabel = getCurrentLabel(value, items);

    /**
     * Handle action event from flyout menu and dispatch a new event with new language value
     * @param {CustomEvent} event - Custom event
     */
    function handleMenuAction(event) {
        dispatch('change', event.detail.key);
    }

    /**
     * Toggle show/hide menu
     */
    function toggleMenu() {
        showFlyout = !showFlyout;
    }

    /**
     *  Get current label by current value
     * @param {String} currentLanguage - current language value e.g. "en"
     * @param {Object[]} languages - list of languages
     * @param {String} languages[].key - value of language
     * @param {String} languages[].label - label of language
     * @returns {String} - label of found current language or empty string
     */
    function getCurrentLabel(currentLanguage, languages) {
        const foundLanguage = languages.find(language => language.key === currentLanguage) || {};

        return foundLanguage.label || '';
    }
</script>

<style>
    div.language-selector-container {
        & button {
            height: 3rem;

            display: flex;
            align-items: center;

            padding: 0;

            cursor: pointer;
            background-color: var(--color-bg-default);
            color: var(--color-text-default);
            font-size: var(--fontsize-body);
            border: none;

            &.inverted {
                @add-mixin inverted;
            }

            &:hover:not(:disabled) span,
            &:active:not(:disabled) span {
                text-decoration: underline;
            }

            &:disabled {
                cursor: not-allowed;
            }

            & span {
                margin: 0 var(--space-1x) 0 var(--space-1x5);
                padding: var(--space-quarter) 0;
            }
        }

        & :global-nested(button) {
            @add-mixin outline-focus -0.75rem;

            &:focus-visible {
                text-decoration: underline;
            }
        }
    }
</style>

<div class="language-selector-container">
    <button class:inverted on:click={toggleMenu} aria-haspopup="true" {disabled} aria-label={__('Select language')}>
        <Icon name="international-16" />
        <span bind:this={labelElement}>{currentLabel}</span>
        <Icon name="caret-down-12" />
    </button>

    <FlyoutMenu bind:open={showFlyout} {anchoring} {items} caller={labelElement} on:action={handleMenuAction} />
</div>
